import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.fuel-station-form', () => {
  void import('./internal/form').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.fuel-station-show-page', () => {
  void import('./internal/show').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.fuel-station-index-page', () => {
  void import('./internal/table').then(({ default: Component }) => Component());
});
